import { render, staticRenderFns } from "./MGroup.vue?vue&type=template&id=63a5aad6&scoped=true&"
import script from "./MGroup.vue?vue&type=script&lang=js&"
export * from "./MGroup.vue?vue&type=script&lang=js&"
import style0 from "./MGroup.vue?vue&type=style&index=0&id=63a5aad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5aad6",
  null
  
)

export default component.exports